import React, { useEffect, useRef, useState } from 'react';
import Sidebar from '../../Components/base/sidebar';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import CreateNew from '../../Components/Button/CreateNew';
import CurrentDashboardTable from '../../Components/Tables/CurrentDashboardTable';
import CurrentApprovalsTable from '../../Components/Tables/CurrentApprovalsTable';
import CurrentDashboardDraftsTable from '../../Components/Tables/CurrentDashBoardDraftsTable';
import AuthModal from '../../Components/Modal/AuthenticateModal';
import { toast } from 'sonner';

interface Item {
    id: number;
    category: string;
    sub_category: string;
    title: string;
    author: string;
    status: string;
    source: 'items' | 'items1' | 'items2'
    // Add more properties as per your item structure
}

export default function Dashboard() {
    const [items, setItems] = useState<Item[]>([]);
    const [items1, setItems1] = useState<Item[]>([]);
    const [items2, setItems2] = useState<Item[]>([]);
    const navigate = useNavigate();
    const [author, setAuthor] = useState<string | undefined | null>(null);
    const [role, setRole] = useState<string | null>(null);
    let isMounted = useRef(true);
    const [id, setItemToDelete] = useState<number | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openAuthModal = () => {
        setIsModalOpen(true); 
    };
    
    const closeAuthModal = () => {
        setIsModalOpen(false); 
    };

    useEffect(() => {
        const storedAuthor = localStorage.getItem('author');
        const storedRole = localStorage.getItem('role');
        setAuthor(storedAuthor);
        setRole(storedRole);
    }, []);

    useEffect(() => {
        isMounted.current = true;

        const fetchData = async () => {
            try {
                const response = await axios.get('https://stagingbackend.pulp.ph/api/v1/short-stories');
                if (isMounted.current) {
                    setItems(response.data.shortStory.data);
                };
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();

        return()=> {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        isMounted.current = true;

        const fetchDataLongStory = async () => {
            try {
                const response = await axios.get('https://stagingbackend.pulp.ph/api/v1/long-stories');
                if (isMounted.current) {
                    setItems1(response.data.longStory.data);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchDataLongStory();

        return () => {
            isMounted.current = false;
        };
    }, []);
    
    useEffect(() => {
        isMounted.current = true;

        const fetchDataCommunity = async () => {
            try {
                const response = await axios.get('https://stagingbackend.pulp.ph/api/v1/communities');
                if (isMounted.current) {
                    setItems2(response.data.Community.data);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchDataCommunity();

        return () => {
            isMounted.current = false;
        };
    }, []);

    const mergedItems: Item[] = [
        ...items.map(item => ({ ...item, source: 'items' as const })),
        ...items1.map(item => ({ ...item, source: 'items1' as const })),
        ...items2.map(item => ({ ...item, source: 'items2' as const }))
    ]

    const handleEditShortstory = (id: number) => {
        navigate('/update/shortStory', { state: { id } }); 
    };

    const handleViewShortstory = (id: number) => {
        window.open(`https://pulpmagazine.pulp.ph/article/${id}`, '_blank');
    };

    const handleDelete = async (id: number) => {
        setItemToDelete(id);
        openAuthModal();
    };

    const confirmDelete = async () => {
        if (id === null) return;
        
        try {
            const authToken = localStorage.getItem('authToken');
            await axios.delete(`https://stagingbackend.pulp.ph/api/v1/shortStory/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                }
            });

            toast.success(<p className="text-[16px]">Content was deleted successfully!</p>, {
                duration: 1500,
            });

            closeAuthModal();
            setItemToDelete(null);

            setTimeout(() => {
                window.location.reload(); 
            }, 1600);
        } catch (error) {
            console.error('There was an error submitting the form!', error);

            toast.error(<p className="text-[16px]">Unable to delete. Please try again.</p>, {
                duration: 1500,
            });
        }
    }

    const handleEditLongstory = (id: number) => {
        navigate('/update/longStory', { state: { id } }); 
    };

    const handleViewLongstory = (id: number) => {
        window.open(`https://pulpmagazine.pulp.ph/article/long_story/${id}`, '_blank');
    };

    const handleDelete1 = async (id: number) => {
        try {
            const authToken = localStorage.getItem('authToken');
            if (!authToken) {
                alert('Authentication token not found!');
                return;
            }

            const confirmDelete = window.confirm('Are you sure you want to delete this content?');
            if (!confirmDelete) {
                return; 
            };

            await axios.delete(`https://stagingbackend.pulp.ph/api/v1/longStory/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                }
            });

            alert('Content Deleted Successfully !!');
            window.location.reload();
        } catch (error) {
            console.error('There was an error submitting the form!', error);
        }
    };

    const handleEditCommunity = (id: number) => {
        navigate('/update/community', { state: { id } }); 
    };

    const handleViewCommunity = (id: number) => {
        window.open(`https://pulpmagazine.pulp.ph/community/${id}`, '_blank');
    };

    const handleDelete2 = async (id: number) => {
        try {
            const authToken = localStorage.getItem('authToken');
            if (!authToken) {
                alert('Authentication token not found!');
                return;
            }

            const confirmDelete = window.confirm('Are you sure you want to delete this content?');
            if (!confirmDelete) {
                return; 
            };

            await axios.delete(`https://stagingbackend.pulp.ph/api/v1/community/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                }
            });

            alert('Content Deleted Successfully !!');
            window.location.reload();
        } catch (error) {
            console.error('There was an error submitting the form!', error);
        }
    };

    return (
        <React.Fragment>
            <AuthModal
                isOpen={isModalOpen}
                onClose={closeAuthModal}
                title="Action Verification"
                content={<div className='text-base mb-3'>Are you sure you want to delete this content?</div>}
                footer={
                    <>
                        <button 
                            className="m-0 px-4 py-2 GraphikSemibold text-sm text-gray-700 bg-gray-200 rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
                            onClick={closeAuthModal}>
                            Close
                        </button>

                        <button 
                            className="m-0 px-4 py-2 GraphikSemibold text-sm text-white bg-red-500 rounded hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400"
                            onClick={confirmDelete}>
                            Confirm
                        </button>
                    </>
                }
            />

            <div className="w-full p-5">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="GraphikSemibold text-[20px]">Dashboard</h2>
                    <CreateNew />
                </div>

                <div className="mt-3">
                    <h3 className="GraphikSemibold text-[16px] mb-2">My Drafts</h3>
                    <CurrentDashboardDraftsTable
                        items={mergedItems}
                        onDelete={handleDelete}
                        onEdit={handleEditShortstory}
                        onView={handleViewShortstory}
                        onDelete1={handleDelete1}
                        onEdit1={handleEditLongstory}
                        onView1={handleViewLongstory}
                        onDelete2={handleDelete2}
                        onEdit2={handleEditCommunity}
                        onView2={handleViewCommunity}
                        author={author}
                    />
                </div>

                <div className="mt-3">
                    <h3 className="GraphikSemibold text-[16px] mb-2">My Latest Short Stories</h3>
                    <CurrentDashboardTable
                        items={items}
                        onDelete={handleDelete}
                        onEdit={handleEditShortstory}
                        onView={handleViewShortstory}
                    />
                </div>

                <div className="mt-3">
                    <h3 className="GraphikSemibold text-[16px] mb-2">My Latest Long Stories</h3>
                    <CurrentDashboardTable
                        items={items1}
                        onDelete={handleDelete1}
                        onEdit={handleEditLongstory}
                        onView={handleViewLongstory}
                    />
                </div>

                <div className="mt-3">
                    <h3 className="GraphikSemibold text-[16px] mb-2">My Latest Community Post</h3>
                    <CurrentDashboardTable
                        items={items2}
                        onDelete={handleDelete2}
                        onEdit={handleEditCommunity}
                        onView={handleViewCommunity}
                    />
                </div>
            </div>
        </React.Fragment>
    )
}
